import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) pollStatus(0);
    else navigate('/subscription');
  }, [sessionId]);

  const pollStatus = async (attempts) => {
    if (attempts >= 15) { setStatus('timeout'); return; }
    try {
      const res = await fetch(`${BACKEND_URL}/api/subscription/checkout-status/${sessionId}`, { credentials: 'include' });
      if (!res.ok) throw new Error();
      const data = await res.json();
      if (data.payment_status === 'paid') {
        setStatus('success');
        setTimeout(() => navigate('/dashboard'), 2000);
        return;
      }
      if (data.status === 'expired') { setStatus('expired'); return; }
    } catch (error) {
      console.error('Error polling subscription status:', error);
    }
    setTimeout(() => pollStatus(attempts + 1), 2000);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        {status === 'processing' && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-amber-500 mx-auto mb-4" />
            <p className="text-white text-lg">Procesando tu pago...</p>
            <p className="text-zinc-500 text-sm mt-2">Esto puede tomar unos segundos</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <p className="text-white text-lg">¡Pago exitoso!</p>
            <p className="text-zinc-500 text-sm mt-2">Redirigiendo al dashboard...</p>
          </>
        )}
        {(status === 'timeout' || status === 'expired') && (
          <>
            <p className="text-white text-lg mb-4">{status === 'timeout' ? 'Tiempo de espera agotado' : 'Sesión expirada'}</p>
            <p className="text-zinc-500 text-sm">Verifica tu correo o contacta soporte.</p>
            <button onClick={() => navigate('/subscription')} className="mt-4 text-amber-500 hover:underline">
              Volver a Suscripción
            </button>
          </>
        )}
      </div>
    </div>
  );
}
